var _rect, _path, _path2, _path3, _path4, _path5, _circle, _ellipse;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgAllColumnsVisibleState = function SvgAllColumnsVisibleState(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 66,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.968,
    y: 21.644,
    width: 47.301,
    height: 38.229,
    rx: 4.25,
    transform: "rotate(-6.916 54.968 21.644)",
    stroke: "#C9CDD9",
    strokeWidth: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.142 39.769c8.917-9.578 27.7-12.5 34.5-4 1.2 1.5 3.5 6 1 9s-7.316 1.691-9.5-1.5c-6.5-9.5 9.5-26.268 29-14.268M105.141 34c4.5 2 12 4.5 18 1 5.5-3.208 7.309-8.127 8.001-9.731.692-1.605 4-8 2.5-13-1.207-4.024-5-5.5-8-4-2.236 1.118-3 4.5-1.5 8.5 2.002 5.337 13.5 10 28.5-.5",
    stroke: "#C9CDD9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.07 3.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.742 26.074a6 6 0 0 1 5.234-6.679l38.518-4.672a6 6 0 0 1 6.679 5.234l.807 6.651-50.431 6.117-.807-6.651Z",
    fill: "#C9CDD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.929 55.318a4.13 4.13 0 0 0 .367-4.381c-.863-1.684-2.421-4.292-4.745-6.57-2.329-2.283-5.472-4.278-9.483-4.614-4.01-.337-7.442 1.107-10.118 2.97-2.671 1.86-4.642 4.17-5.774 5.687a4.131 4.131 0 0 0-.367 4.381c.863 1.684 2.422 4.292 4.746 6.57 2.328 2.283 5.472 4.278 9.482 4.614 4.01.337 7.442-1.107 10.118-2.97 2.671-1.86 4.643-4.171 5.774-5.688Z",
    fill: "#C9CDD9",
    stroke: "#fff",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m79.656 28.766 3.386 27.918",
    stroke: "#C9CDD9",
    strokeWidth: 3.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.849 52.19c.25.488.203 1.044-.124 1.483-1.035 1.386-2.802 3.447-5.141 5.075-2.331 1.623-5.135 2.754-8.317 2.487-3.183-.267-5.759-1.85-7.787-3.837-2.036-1.996-3.435-4.322-4.224-5.861a1.381 1.381 0 0 1 .124-1.482c1.035-1.387 2.802-3.447 5.141-5.075 2.331-1.622 5.135-2.754 8.318-2.487 3.182.267 5.759 1.85 7.787 3.837 2.035 1.996 3.434 4.322 4.223 5.86Z",
    fill: "#fff",
    stroke: "#C9CDD9",
    strokeWidth: 3.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110.054,
    cy: 51.864,
    r: 5.07,
    transform: "rotate(4.794 110.054 51.864)",
    fill: "#C9CDD9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.215,
    cy: 48.418,
    rx: 2.408,
    ry: 1.705,
    transform: "rotate(-31.73 108.215 48.418)",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAllColumnsVisibleState, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/all-columns-visible-state.9cd4709b68e11cc3efa7a0ea156f57d8.svg";
export { ForwardRef as ReactComponent };